import { MessageBox, Message } from 'element-ui';
import _ from 'lodash';
import router from './router';
import { TOKEN_STORAGE_KEY } from '@/constants';
import { i18n } from './i18n';
import { request } from 'beans-admin-plugin';

export default {
  componentPrefix: 'bean',
  screen: {
    sm: 768,
    md: 992,
    lg: 1200,
    xl: 1920
  },
  request: {
    baseURL: '/admin_api/v1',
    timeout: 60000,
    onSend: (request) => {
      const token = localStorage.getItem(TOKEN_STORAGE_KEY);
      const locale = i18n.locale;

      if (request.url.includes('amazonaws')) {
        return ; // 上传到 aws S3 不配置 Authorization header，不然会报错
      }

      if (!request.headers.Authorization && token) {
        request.headers.Authorization = token;
      }
      if (localStorage.getItem('currentRoleId')) {
        request.headers['Current-Role-Id'] = +localStorage.getItem('currentRoleId')
      }
      if (!request.headers.Locale && locale) {
        request.headers.Locale = locale;
      }
    },
    onError: (err) => {
      const { error_message, message, messages, error, code } = _.get(err, 'response.data', {})
      err.message = error_message || message || messages || error || err.message;
      err.api_code = code;
      switch (err.status) {
        case 401: {
          localStorage.removeItem(TOKEN_STORAGE_KEY);
          if (router.currentRoute.name !== 'login') {
            router.replace({ name: 'login' });
          }

          if (err.api_code === 40101) {
            Message.error(err.message);
          } else {
            Message.info(i18n.t('pleaseLogin'));
          }
          break;
        }
        case 403:
          // 账号角色被移除时
          if (err.api_code === 40303) {
            localStorage.removeItem('currentRoleId');
            router.replace({ name: 'home' });
            location.reload()
          } else {
            router.replace({ name: '403' });
          }
          break;
        default: {
          if (_.get(err, 'request.$alert') !== false) {
            MessageBox.alert(err.message, { title: i18n.t('error') })
          }
        }
      }
      return err;
    }
  },
  upload: {
    // directUploadURL: '/active_storage/direct_upload',
    resourceBlobURL: '/active_storage/blobs/read_options',
    customUpload: async (file, body, { onProgress = _.noop } = {}) => {
      onProgress(0);
      const result = await request.post('/active_storage/direct_upload', body);
      // 1小时超时
      const uploadTask = request.put(result.direct_upload.url, file.slice(), { headers: result.direct_upload.headers, timeout: 1 * 60 * 60 * 1000 });
      // 处理进度
      uploadTask.engine.upload.onprogress = ({ total, loaded }) => onProgress(Math.floor(loaded / total * 100));
      await uploadTask;
      return {
        ...result,
        url: result.direct_upload.url,
        blob_url: result.direct_upload.blob_url
      };
    },
    // customUpload: async (file, body, { onProgress = _.noop } = {}) => {
    //   const result = await request.post('/active_storage/direct_upload', body);
    //   // 1小时超时
    //   const formData = new FormData();
    //   formData.append('file', file);
    //   formData.append('key', result.key);
    //   formData.append('token', result.direct_upload.headers['x-token']);

    //   const task = request.post(
    //     result.direct_upload.url,
    //     formData,
    //     { headers: { 'Content-Type': 'multipart/form-data' }, timeout: 1 * 60 * 60 * 1000 });

    //   // 上传进度
    //   task.engine.upload.onprogress = (e) => {
    //     const { total, loaded } = e;
    //     const progressPct = Math.floor(loaded / total * 100);
    //     onProgress(progressPct);
    //   }

    //   await task;

    //   return {
    //     ...result,
    //     url: result.direct_upload.url,
    //     blob_url: result.direct_upload.blob_url
    //   };
    // },
    // resourceUploader: {
    //   // resouceUpload筛选column
    //   filterColumns: [],
    //   // resouceUpload上传表单column
    //   formColumns: []
    // }
  },
  sourcePage: {
    // prop = id 默认加上排序
    sortable: ['id'],
    columns() {
      return []
    }
  },
  i18n: {
    localeStorageKey: 'locale',
    locales: {
      zh_cn: '简体中文',
      en: 'English',
    },
  },
  ckeditor: {
    directUploadExtraBody: {
      source: 'wysiwyg'
    }
  }
}
